import {
  createContext,
  useContext,
  useMemo,
  useState,
  type ReactNode,
} from "react";
import type { AssistantSurfaceContext } from "@gsb-core/react-assistant";

type AssistantSurfaceContextValue = {
  readonly surfaceContext: AssistantSurfaceContext;
  readonly setSurfaceContext: (surfaceContext: AssistantSurfaceContext) => void;
};

const defaultSurfaceContext: AssistantSurfaceContext = { route: "/dashboard" };
const AssistantSurfaceContextState =
  createContext<AssistantSurfaceContextValue | null>(null);

export function AssistantSurfaceContextProvider({
  children,
}: {
  readonly children: ReactNode;
}) {
  const [surfaceContext, setSurfaceContext] = useState(defaultSurfaceContext);
  const value = useMemo(
    () => ({ surfaceContext, setSurfaceContext }),
    [surfaceContext],
  );

  return (
    <AssistantSurfaceContextState.Provider value={value}>
      {children}
    </AssistantSurfaceContextState.Provider>
  );
}

export function useAssistantSurfaceContextState(): AssistantSurfaceContextValue {
  const context = useContext(AssistantSurfaceContextState);
  if (context === null) {
    throw new Error(
      "useAssistantSurfaceContextState must be used within an AssistantSurfaceContextProvider.",
    );
  }
  return context;
}
